import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import daCommon from './locales/da/common.json';
import daLanding from './locales/da/landing.json';
import daAuth from './locales/da/auth.json';
import daDashboard from './locales/da/dashboard.json';
import daSession from './locales/da/session.json';
import daTeaching from './locales/da/teaching.json';
import daSettings from './locales/da/settings.json';
import daErrors from './locales/da/errors.json';
import daAnna from './locales/da/anna.json';
import daLibrary from './locales/da/library.json';
import daOnboarding from './locales/da/onboarding.json';
import daPreparation from './locales/da/preparation.json';
import daAnnaHaiku from './locales/da/anna-haiku.json';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enSession from './locales/en/session.json';
import enTeaching from './locales/en/teaching.json';
import enSettings from './locales/en/settings.json';
import enErrors from './locales/en/errors.json';
import enAnna from './locales/en/anna.json';
import enLibrary from './locales/en/library.json';
import enOnboarding from './locales/en/onboarding.json';
import enPreparation from './locales/en/preparation.json';
import enAnnaHaiku from './locales/en/anna-haiku.json';

export const supportedLanguages = ['da', 'en'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      da: {
        common: daCommon,
        landing: daLanding,
        auth: daAuth,
        dashboard: daDashboard,
        session: daSession,
        teaching: daTeaching,
        settings: daSettings,
        errors: daErrors,
        anna: daAnna,
        library: daLibrary,
        onboarding: daOnboarding,
        preparation: daPreparation,
        'anna-haiku': daAnnaHaiku,
      },
      en: {
        common: enCommon,
        landing: enLanding,
        auth: enAuth,
        dashboard: enDashboard,
        session: enSession,
        teaching: enTeaching,
        settings: enSettings,
        errors: enErrors,
        anna: enAnna,
        library: enLibrary,
        onboarding: enOnboarding,
        preparation: enPreparation,
        'anna-haiku': enAnnaHaiku,
      },
    },
    fallbackLng: 'da',
    defaultNS: 'common',
    ns: ['common', 'landing', 'auth', 'dashboard', 'session', 'teaching', 'settings', 'errors', 'anna', 'library', 'onboarding', 'preparation', 'anna-haiku'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lyra-language',
      caches: ['localStorage'],
    },
  });

export default i18n;
